import { render } from "./WorkoutWorkbook.vue?vue&type=template&id=270ee27c&scoped=true"
import script from "./WorkoutWorkbook.vue?vue&type=script&lang=js"
export * from "./WorkoutWorkbook.vue?vue&type=script&lang=js"

import "./WorkoutWorkbook.vue?vue&type=style&index=0&id=270ee27c&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270ee27c"],['__file',"src/views/post/WorkoutWorkbook.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "270ee27c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('270ee27c', __exports__)) {
    console.log('reload')
    api.reload('270ee27c', __exports__)
  }
  
  module.hot.accept("./WorkoutWorkbook.vue?vue&type=template&id=270ee27c&scoped=true", () => {
    console.log('re-render')
    api.rerender('270ee27c', render)
  })

}


export default __exports__